import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DictationSettingsState {
  /** Preferred input device id, or undefined for the browser default. */
  deviceId?: string;
  setDeviceId: (deviceId?: string) => void;
}

/**
 * Persisted dictation preferences. Currently just the chosen input device,
 * remembered across sessions so the user does not re-pick their mic each time.
 */
export const useDictationSettingsStore = create<DictationSettingsState>()(
  persist(
    (set) => ({
      deviceId: undefined,
      setDeviceId: (deviceId) => set({ deviceId }),
    }),
    { name: 'strive-dictation-settings' },
  ),
);
